import React from "react";
import ReactApexChart from "react-apexcharts";

class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: this.props.series,

      options: {
        colors: this.props.colors, //["#15a4fa"] : ["#47bac1"],
        chart: {
          height: 300,
          type: "radialBar",
          offsetY: 0,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: "1",
              size: this.props.hollow || "75%",
            },
            track: {
              background: "#d9d9d9",
              strokeWidth: "100%",
              margin: 2, // margin is in pixels,
            },
            dataLabels: {
              name: {
                show: /*this.props.hollow ? false :*/ true,
                offsetY: 25,
                offsetX: 0,
                fontSize: "11px",
                color: "#707c8d",
                textAnchor: "start",
              },
              value: {
                show: true,
                offsetY: this.props.hollow ? 12 : -15,
                offsetX: 0,
                fontSize: this.props.hollow ? "35px" : "25px",
                fontFamily: "Arial",
                fontWeight: "530",
                color: "#677485",
              },
            },
          },
        },
        grid: {
          padding: {
            top: 5,
          },
        },
        stroke: {
          lineCap: "round",
        },

        labels: [this.props.dimension],
      },
    };
  }

  render() {
    return (
      <ReactApexChart
        width="100%"
        options={this.state.options}
        series={this.props.series}
        type="radialBar"
      />
    );
  }
}
export default ApexChart;
